
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next-boost",
      function () {
        return require("private-next-pages/next-boost.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/next-boost"])
      });
    }
  